import { ModuleDefinition } from '@project/scripts/modules/definition';

export default [
  { selector: '[data-tariff-lookup]', moduleName: 'TariffLookup' },
] as ModuleDefinition[];
